exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title[data-v-227d1830]{font-size:18px}.info[data-v-227d1830],.title[data-v-227d1830]{font-weight:700}.info[data-v-227d1830]{font-size:16px}.desc[data-v-227d1830]{padding:20px;font-size:14px}", ""]);

// exports
